import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { BrandCapitalHero } from './components/BrandCapitalHero';
import { CosaFacciamo } from './components/CosaFacciamo';
import { MetodoTeaser } from './components/MetodoTeaser';
import { PerChiLavoriamo } from './components/PerChiLavoriamo';
import { DifferenzaBrandCapital } from './components/DifferenzaBrandCapital';
import { BrandCapitalCTA } from './components/BrandCapitalCTA';
import { useSEO } from '../../utils/seo';

export function BrandCapitalPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'Brand Capital - Metodologia Scientifica Valutazione Brand Italia',
    description: 'Scopri Brand Capital, l\'unica metodologia scientifica certificata per la valutazione del brand. Perizie difendibili in tribunale, riconosciute da commercialisti, revisori e investitori in tutta Italia.',
    keywords: 'brand capital, metodologia valutazione brand, perizia certificata, valutazione scientifica marchio',
    canonical: `${siteUrl}/brand-capital`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Brand Capital - Metodologia di Valutazione',
      description: 'Metodologia scientifica certificata per la valutazione del brand e perizie difendibili',
      provider: {
        '@type': 'ProfessionalService',
        name: 'Brand Capital',
        url: siteUrl
      },
      areaServed: 'IT',
      serviceType: 'Brand Valuation Methodology'
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <BrandCapitalHero />
      <CosaFacciamo />
      <MetodoTeaser />
      <PerChiLavoriamo />
      <DifferenzaBrandCapital />
      <BrandCapitalCTA />
      <Footer />
    </div>
  );
}

export default BrandCapitalPage;
